import { render, staticRenderFns } from "./ECAbout.vue?vue&type=template&id=3c51239b&scoped=true&"
import script from "./ECAbout.vue?vue&type=script&lang=ts&"
export * from "./ECAbout.vue?vue&type=script&lang=ts&"
import style0 from "./ECAbout.vue?vue&type=style&index=0&id=3c51239b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51239b",
  null
  
)

export default component.exports